<template>
<div>
	<div class="info_title">
		{{label}}
	</div>
	<div class="info_value" v-html="text">

	</div>
</div>
</template>

<script>
export default {
	props: {
		text: String,
		label: String
	}
}
</script>

<style scoped>
.info_title {
	font-size: 12px;
	color: rgba(0, 0, 0, 0.54);
}
.info_value {
	font-size: 16px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.54);
	padding-bottom: 5px;
	min-height: 30px;
}
</style>
